import {
	FormControl,
	Grid,
	MenuItem,
	Select,
	Box,
	Button,
} from '@mui/material';
import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import React, { useEffect, useState } from 'react';
import Patients from './Patients';
import MissedChargesSchedular from './MissedChargesSchedular';
import {
	getAdmittedPatients,
	getLocation,
	getPracticeStaff,
	getVisit,
} from '../../../services/api/apiManager';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function MissedChargeFinder() {
	const practice_id = localStorage.getItem('practice_id');
	const [provider, setProvider] = useState('');
	const [location, setLocation] = useState('');
	const [staffList, setStaffList] = useState([]);
	const [locations, setLocations] = useState([]);
	const [visitData, setVisitData] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [loading, setLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const [filteredVisits, setFilteredVisits] = useState(visitData);

	const totalPages = Math.ceil(filteredVisits?.length / rowsPerPage);

	const handleChangePage = (newPage) => {
		if (newPage > 0) {
			setCurrentPage(newPage);
		}
	};

	const handleChangeRowsPerPage = (e) => {
		setRowsPerPage(parseInt(e.target.value));
		setCurrentPage(1);
	};

	const getDataForAdmittedPatients = async () => {
		try {
			debugger;
			setLoading(true);
			const response = await getAdmittedPatients(practice_id);
			if (response?.status === 200) {
				setVisitData(response?.data);
			} else {
				setVisitData([]);
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoading(false);
		}
	};

	useEffect(() => {
		getDataForAdmittedPatients();
	}, []);

	useEffect(() => {
		if (
			visitData &&
			searchText?.length === 0 &&
			provider?.length === 0 &&
			location?.length === 0
		) {
			setFilteredVisits(visitData);
		}
	}, [visitData]);

	const handleProvider = (event) => {
		debugger;
		const selectedProvider = event.target.value;
		setProvider(selectedProvider);

		const filterVisits = selectedProvider
			? visitData?.filter((visit) => visit?.providerid == selectedProvider)
			: visitData;

		setFilteredVisits(filterVisits);
	};

	const handleLocation = (event) => {
		const selectedLocation = event.target.value;
		setLocation(selectedLocation);
		const filterVisits = selectedLocation
			? visitData?.filter((visit) => visit?.locationid == selectedLocation)
			: visitData;

		setFilteredVisits(filterVisits);
	};

	const fetchPracticeStaff = async () => {
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setStaffList(res.data);
		} else {
			setStaffList([]);
		}
	};

	const getLocationsData = async () => {
		const resp = await getLocation();
		if (resp?.status === 200) {
			setLocations(resp?.data);
		}
	};

	useEffect(() => {
		fetchPracticeStaff();
		getLocationsData();
	}, []);

	return (
		<Grid container>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				sx={{ border: '1px solid #00000026', background: 'white' }}
			>
				<Patients
					visitData={visitData}
					filteredVisits={filteredVisits}
					setFilteredVisits={setFilteredVisits}
					setVisitData={setVisitData}
					loading={loading}
					setLoading={setLoading}
					getDataForAdmittedPatients={getDataForAdmittedPatients}
					searchText={searchText}
					setSearchText={setSearchText}
					provider={provider}
					location={location}
					handleProvider={handleProvider}
					handleLocation={handleLocation}
					locations={locations}
					staffList={staffList}
					currentPage={currentPage}
					rowsPerPage={rowsPerPage}
				/>
			</Grid>
			<Grid
				item
				xl={12}
				xs={12}
				lg={12}
				md={12}
				sm={12}
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
					padding: '5px 10px',
					gap: '5px',
				}}
			>
				<span style={{ marginRight: '2px' }}>Rows per page:</span>
				<Select
					value={rowsPerPage}
					onChange={(e) => handleChangeRowsPerPage(e)}
					displayEmpty
					size="small"
				>
					{[5, 10, 50, 100].map((option) => (
						<MenuItem key={option} value={option}>
							{option}
						</MenuItem>
					))}
				</Select>
				<span>{`${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
					currentPage * rowsPerPage,
					filteredVisits?.length
				)} of ${filteredVisits?.length}`}</span>

				<Button
					onClick={() => handleChangePage(currentPage - 1)}
					disabled={currentPage === 1}
				>
					<ArrowBackIosNewIcon
						style={{ cursor: 'pointer', marginRight: '20px' }}
						fontSize="15px"
					/>
				</Button>
				<Button
					onClick={() => handleChangePage(currentPage + 1)}
					disabled={currentPage === totalPages}
				>
					<ArrowForwardIosIcon style={{ cursor: 'pointer' }} fontSize="15px" />
				</Button>
			</Grid>
		</Grid>
	);
}

export default MissedChargeFinder;
